import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/services/auth-service.service';

@Component({
  selector: 'app-proposal-cards',
  templateUrl: './proposal-cards.component.html',
  styleUrls: ['./proposal-cards.component.css']
})
export class ProposalCardsComponent implements OnInit {
  currentDate = new Date();
  createdDate = new Date();
  @Input() title: string;
  @Input() dataItems: any;
  @Output() actionId: EventEmitter<any> = new EventEmitter();
  constructor(private auth: AuthServiceService, private toaster: ToastrService) {
  }
  public groupByList = []

  ngOnInit() {
    this.groupByList = [
      {
        name: 'Service Line',
        value: 'ServiceLine'
      },
      {
        name: 'Domain',
        value: 'Domain'
      },
      {
        name: 'Location',
        value: 'Location'
      },
      {
        name: 'Proposal Status',
        value: 'ProposalStatus'
      },
      {
        name: 'Size',
        value: 'Size'
      },
      {
        name: 'Delivery Methodology',
        value: 'DeliveryMethod'
      },
      {
        name: 'Service Offering',
        value: 'ServiceOffering'
      },
      {
        name: 'Tech Stack',
        value: 'TechStack'
      },
      {
        name: 'Primary Prospect',
        value: 'PrimaryProspect'
      }
    ];
  }
  accordionState: { [key: string]: boolean } = {}; // Store accordion states

  // Functions
  toggleAccordion(key: string) {
    this.accordionState[key] = !this.accordionState[key];
  }

  isAccordionOpen(key: string): boolean {
    return this.accordionState[key] || false;
  }
  calculateDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
  }
  getFirstLetter(data) {
    if (data != null) {
      return data[0].toUpperCase();
    }
  }
  downloadProposalCard(data) {
    if (data.artefactsCount == 0) {
      this.toaster.error("No files to download")
    }
    else {
      var obj = {
        Action: "download",
        data: data
      }
      this.actionId.emit(obj);

    }
  }
  delProposalCard(data) {
    var obj = {
      Action: "delete",
      data: data
    }
    this.actionId.emit(obj);
  }
  viewProposalCard(data) {
    var obj = {
      Action: "view",
      id: data.id
    }
    this.actionId.emit(obj);
  }
  editProposalCard(data) {
    var obj = {
      Action: "edit",
      id: data.id
    }
    this.actionId.emit(obj);
  }
  getStatusClass(value) {
    var str = "";
    if (value != null) {
      value.split(" ").forEach(x => {
        str = str + x.toLowerCase()
      })
    }
    return str;
  }
  getString(values) {
    var str = "";
    values.forEach(x => {
      str = str + x + " , ";
    })
    return str.substring(0, str.length - 2);
  }
  getSource(domain) {
    if (domain) {
      domain = domain.toLowerCase()
      if (domain.indexOf('health') > -1)
        return "health_and_safety"
      else if (domain.indexOf('bank') > -1 || domain.indexOf('finan') > -1 || domain.indexOf('trad') > -1 || domain.indexOf('commerc') > -1)
        return "account_balance"
      else if (domain.indexOf('retail') > -1)
        return "shopping_cart"
      else if (domain.indexOf('communication') > -1)
        return "contact_mail"
      else if (domain.indexOf('travel') > -1)
        return "map"
      else
        return "engineering"
    }
  }
  isAuthorizedUser(data) {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Proposal.Admin') >= 0)
      return true
    else {
      if (roles.indexOf('Proposal.User') >= 0) {
        if (data.createdBy == this.auth.getEmailId())
          return true;
      }
    }
    return false;
  }
}
